import { useMediaQuery } from '@/hooks/useMediaQuery';
import type { EpisodeSummary, StreamRef, TvDetails } from '@/types/streaming';
import { EpisodePickerDesktop } from './EpisodePickerDesktop';

interface Props {
  streamRef: StreamRef;
  details: TvDetails;
  episodes: Record<number, EpisodeSummary[]>;
  loadSeason: (season: number) => Promise<void>;
}

export function EpisodePicker({
  streamRef,
  details,
  episodes,
  loadSeason,
}: Props): JSX.Element | null {
  // Mobile uses the inline TvEpisodeControls dropdowns in the player area
  // instead — the legacy bottom-sheet variant was hidden behind the
  // hamburger drawer and the inline pickers don't have that problem.
  const isMobile = useMediaQuery('(max-width: 960px)');

  if (streamRef.type !== 'tv') return null;
  if (isMobile) return null;

  // TMDB exposes a "Season 0" bucket for specials / behind-the-scenes.
  // The picker is for canonical seasons only.
  const seasons = details.seasons.filter((s) => s.seasonNumber !== 0);

  return (
    <EpisodePickerDesktop
      streamRef={streamRef}
      seasons={seasons}
      episodes={episodes}
      loadSeason={loadSeason}
    />
  );
}
